import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import noop from '../utils/noop';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import CloseBigIcon from '@wix/da-ds/pkg/Icons/CloseBig';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { ResourceType } from '../types/resource';
import UserSampleGallery from './UserSampleGallery';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './WatchSuggestionList.scss';
// todo: could be moved into browse now
export const WatchSuggestionList = ({ watchSuggestions, numSuggestionsShown, currentUserId, duperbrowseContextTitle, className, allowUnsuggest, unsuggestUser = noop, onWatch = noop })=>{
    const { t } = useTranslation();
    const [hiddenUserIds, setHiddenUserIds] = useState([]);
    const removeAndUnsuggestUser = useCallback((userId)=>{
        unsuggestUser(userId);
        setHiddenUserIds([
            ...hiddenUserIds,
            userId
        ]);
    }, [
        hiddenUserIds,
        setHiddenUserIds,
        unsuggestUser
    ]);
    const toBeRendered = watchSuggestions.map((suggestion, i)=>_object_spread_props(_object_spread({}, suggestion), {
            rank: i
        })).filter(({ user })=>hiddenUserIds.indexOf(user.userId) < 0).slice(0, numSuggestionsShown);
    return /*#__PURE__*/ React.createElement("ul", {
        className: className
    }, toBeRendered.length ? toBeRendered.map(({ user, deviations, rank })=>/*#__PURE__*/ React.createElement("li", {
            key: user.useridUuid,
            className: s['list-item']
        }, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
            value: {
                rank
            }
        }, /*#__PURE__*/ React.createElement(UserSampleGallery, {
            className: s['user-sample-gallery'],
            user: user,
            deviations: deviations,
            // this... shouldn't happen...
            isOwnUser: user.userId === currentUserId,
            duperbrowseContextTitle: duperbrowseContextTitle,
            onWatch: onWatch
        }), allowUnsuggest && /*#__PURE__*/ React.createElement(IconButton, {
            className: s['unsuggest-button'],
            size: "small",
            icon: CloseBigIcon,
            onClick: ()=>removeAndUnsuggestUser(user.userId),
            "aria-label": t('watchSuggestionsV2.a11y.unsuggest'),
            biData: BiData({
                evid: 406,
                sectionname: 'watch_suggestions',
                typeid: ResourceType.USER,
                itemid: user.userId,
                items_selected_count: 1
            })
        })))) : /*#__PURE__*/ React.createElement("p", {
        className: s['empty']
    }, t('watchSuggestionsV2.empty')));
};
WatchSuggestionList.displayName = 'WatchSuggestionList';
export default WatchSuggestionList;

//# sourceMappingURL=WatchSuggestionList.js.map